<template>
  <div class="q-pa-md flex flex-center column">
    <q-card v-if="loading" class="q-pa-lg shadow-2">
      <q-card-section class="text-center">
        <q-spinner
          color="primary"
          size="3em"
        />
        <p class="q-mt-md">{{ statusMessage }}</p>
      </q-card-section>
    </q-card>
    
    <!-- Show notification status directly in the UI -->
    <q-card v-if="notificationMessage" class="q-mt-md q-pa-md" :class="notificationColor">
      <q-card-section class="text-white text-center">
        {{ notificationMessage }}
      </q-card-section>
    </q-card>
  </div>
</template>
 
<script>
export default {
  name: 'LoginAs',
   
  data() {
    return {
      loading: true,
      statusMessage: 'Logging in as impersonated user...',
      notificationMessage: '',
      notificationColor: '',
      redirectTimer: null
    }
  },
   
  methods: {
    showNotification(message, color, isSuccess = false) {
      // Clear any existing redirect timer
      if (this.redirectTimer) {
        clearTimeout(this.redirectTimer);
      }
      
      // Update notification state
      this.notificationMessage = message;
      this.notificationColor = color;
      
      // Schedule redirect after ensuring notification is visible
      this.redirectTimer = setTimeout(() => {
        if (isSuccess) {
          this.redirectToProjects();
        } else {
          this.redirectToHome();
        }
      }, 2500);
    },
    
    redirectToProjects() {
      console.log('Redirecting to projects...');
      
      // Get current domain WITHOUT port number
      const currentDomain = window.location.hostname;
      const protocol = window.location.protocol;
      
      // Attempt multiple redirection methods
      try {
        // 1. Try using the current URL with pathname only
        const pathOnlyUrl = '/app/projects';
        console.log('Trying path-only redirect to:', pathOnlyUrl);
        
        // Skip Vue Router to avoid any routing issues
        window.location.replace(pathOnlyUrl);
      } catch (e) {
        console.error('Redirection error:', e);
      }
    },
    
    redirectToHome() {
      window.location.replace('/');
    }
  },
   
  created() {
    
    // The token might be in different places depending on router mode (hash or history)
    let token = null;
     
    // Try to get from route query params
    if (this.$route.query && this.$route.query.token) {
      token = this.$route.query.token;
    }
    // Try to extract from hash if not in query params
    else {
      const hashParams = window.location.hash.split('?')[1];
      if (hashParams) {
        const urlParams = new URLSearchParams(hashParams);
        token = urlParams.get('token');
      }
       
      // As a last resort, try regex
      if (!token) {
        const tokenMatch = window.location.hash.match(/token=([^&]+)/);
        if (tokenMatch && tokenMatch[1]) {
          token = tokenMatch[1];
        }
      }
    }
     
    if (token) {
      // Store the token in cookie with proper path to ensure availability across domains
      this.$q.cookies.set('token', token, { 
        path: '/',
        secure: window.location.protocol === 'https:',
        sameSite: 'Lax'
      });
       
      // Update status
      this.statusMessage = 'Token trovato, autenticazione in corso...';
       
      // Get user data with new token to confirm it works
      this.$axios.get('/api/user')
        .then(response => {
           
          // Update store if needed
          if (this.$store && this.$store.dispatch) {
            this.$store.dispatch('updateUser', response.data);
          }
           
          // Show success notification and mark as successful login
          this.showNotification('Accesso come utente impersonato avvenuto con successo', 'bg-positive', true);
        })
        .catch(error => {
          console.error('Error getting user data:', error);
          this.showNotification('Errore durante l\'impersonazione dell\'utente', 'bg-negative', false);
          this.loading = false;
        });
    } else {
      // No token found
      this.showNotification('Token di impersonazione mancante o non valido', 'bg-negative', false);
      this.loading = false;
    }
  },
  
  beforeDestroy() {
    // Clean up any pending timers
    if (this.redirectTimer) {
      clearTimeout(this.redirectTimer);
    }
  }
}
</script>